import { SyncMode, SyncStatus } from "./api-types";

export const SYNC_MODE_LABELS: Record<SyncMode, string> = {
  ifEmpty: "If Empty",
  always: "Always",
  ignore: "Ignore",
  custom: "Custom",
};

export const FIELD_TYPE_LABELS: Record<string, string> = {
  choice: "Choice Field",
  text: "Text Field",
  date: "Date Field",
  currency: "Currency Field",
  lookup: "Lookup Field",
  boolean: "Boolean Field",
  integer: "Integer Field",
  decimal: "Decimal Field",
  memo: "Memo Field",
};

export const getSyncModeClass = (syncMode: SyncMode): string => {
  switch (syncMode) {
    case "ifEmpty":
      return "bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200";
    case "always":
      return "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200";
    case "ignore":
      return "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200";
    case "custom":
      return "bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200";
    default:
      return "bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-200";
  }
};

export const getSyncModeColor = (syncMode: SyncMode): string => {
  switch (syncMode) {
    case "ifEmpty":
      return "#D0E7F8";
    case "always":
      return "#D5E5D5";
    case "ignore":
      return "#F5D7D7";
    case "custom":
      return "#F5F0D5";
    default:
      return "#EEEEEE";
  }
};

export const getFieldTypeClass = (fieldType: string): string => {
  switch (fieldType) {
    case "choice":
      return "bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200";
    case "text":
      return "bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-200";
    case "date":
      return "bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200";
    case "currency":
      return "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200";
    case "lookup":
      return "bg-indigo-100 text-indigo-800 dark:bg-indigo-900 dark:text-indigo-200";
    case "boolean":
      return "bg-pink-100 text-pink-800 dark:bg-pink-900 dark:text-pink-200";
    case "integer":
      return "bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200";
    case "decimal":
      return "bg-teal-100 text-teal-800 dark:bg-teal-900 dark:text-teal-200";
    case "memo":
      return "bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-200";
    default:
      return "bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-200";
  }
};

export const getStatusClass = (status: string | undefined): string => {
  switch (status) {
    case "done":
    case "active":
      return "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200";
    case "error":
      return "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200";
    case "pending":
      return "bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200";
    case "no_update_needed":
    case "inactive":
      return "bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200";
    case "skipped":
      return "bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-200";
    case "no_child_found":
      return "bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-200";
    default:
      return "bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-200";
  }
};
